import { ObjectMeta } from "@supernova-studio/model";
import { z } from "zod";
import { DTOThemeOverride } from "./override";

//
// Read
//

export const DTOTheme = z.object({
  id: z.string(),
  persistentId: z.string(),
  designSystemVersionId: z.string(),
  brandId: z.string(),

  meta: ObjectMeta,
  codeName: z.string(),

  overrides: DTOThemeOverride.array(),
});

export const DTOThemeResponse = z.object({
  theme: DTOTheme,
});

export const DTOThemeListResponse = z.object({
  themes: DTOTheme.array(),
});

export type DTOTheme = z.infer<typeof DTOTheme>;
export type DTOThemeResponse = z.infer<typeof DTOThemeResponse>;
export type DTOThemeListResponse = z.infer<typeof DTOThemeListResponse>;

//
// Write
//

export const DTOThemeCreatePayload = z.object({
  meta: ObjectMeta,
  persistentId: z.string(),
  brandId: z.string(),
  codeName: z.string(),
  overrides: DTOThemeOverride.array(),
});

export type DTOThemeCreatePayload = z.infer<typeof DTOThemeCreatePayload>;
